<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_inventory_reporting_period</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="棚卸報告年度区分"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
             <button
            :disabled="deleteBtnDisabled || checkUserPermission(true,permissionMode.DELETE) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">{{deleteText}}</button>
            <button :disabled=" checkUserPermission(true,permissionMode.ADD) == false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew">新規</button>
             <confirmation-modal tag="deletemailMessageModal" @done="onConfirmDelete" />
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_master_inventory_reporting_period';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      api_name:"master_inventory_reporting_period",
      page_acl: acl.master,
      detail_page:"page_0041_master_inventory_reporting_period_detail",
      execute_filter_on_back:true,
      link_to_open:"#"
    };
  },
  computed: {
    deleteBtnDisabled(){
      return this.formOutputQty == 0;
    },
    deleteText(){
      if(this.deleteBtnDisabled){
        return "削除";
      }else{
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.reporting_period, {}),
        utils.extend(fields.expiration_date_start, {}),
        utils.extend(fields.expiration_date_end, {}),
        utils.extend(fields.last_reporting_period, {}),
        utils.extend(fields.editable, {}),
      ];
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
  },
  methods: {
    onDelete(){
      bus.$emit("deletemailMessageModal",{
        title: "削除",
        message: "棚卸報告年度区分の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0){
          return;
        }
        var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
        var vm = this
        this.commonDeleteArr(vm,arr,()=>{
          // All Deleted
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile(){
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    onEdit(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"edit"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    },
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_inventory_reporting_period.vue?33f17c26